// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "8175dfa0b75d81f4185140479aceacd4" + ".js";
};